import { useState } from 'react'
import classes from './TextInput.module.css'

const TextInput = ({
  children,
  required,
  change,
  disabled,
  labelClasses,
  value,
  onBlurCustom,
  onFocusCustom,
  error,
  prefix,
  ...rest
}) => {
  const [focusClass, SetfocusClass] = useState('')

  const handleFocus = e => {
    SetfocusClass(classes.is_active)
    onFocusCustom && onFocusCustom(e)
  }

  const handleBlur = e => {
    SetfocusClass('')
    onBlurCustom && onBlurCustom(e)
  }

  const inputElement = (
    <input
      disabled={disabled}
      onChange={change}
      {...rest}
      required={required}
      value={value}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={`${classes.input} bg-transparent border-none pt-6 pb-2 ${
        prefix ? 'flex-1 min-w-0 pl-1 pr-5' : 'w-full px-5'
      }`}
    />
  )

  return (
    <>
      <label
        className={`${classes.label}
          relative
          block
          border-1 border-solid border-white
          mx-1.5
          my-2
          px-2
          pt-2
          pb-4
          md:mx-3.5 md:my-5
          flex-grow
          font-[sans-serif]
          ${labelClasses}
        `}
      >
        <span
          className={`${classes.span}
            absolute
            text-darkGray
            top-2
            md:top-4
            text-base
            transition-transform
            ${prefix ? 'left-8 md:left-11' : 'left-4 md:left-7'}
            ${value && value.length > 0 ? 'hidden' : ''}
            ${focusClass}
          `}
        >
          {children}
          {required && ' *'}
        </span>
        {prefix ? (
          <div className="flex items-baseline">
            <span
              aria-hidden="true"
              className="pt-6 pb-2 pl-5 select-none pointer-events-none"
            >
              {prefix}
            </span>
            {inputElement}
          </div>
        ) : (
          inputElement
        )}
        {error && <div className="mt-1 text-xs text-red pt-2">{error}</div>}
      </label>
    </>
  )
}

export default TextInput
